import { render, staticRenderFns } from "./add.vue?vue&type=template&id=a5be26b6&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=a5be26b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5be26b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5be26b6')) {
      api.createRecord('a5be26b6', component.options)
    } else {
      api.reload('a5be26b6', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=a5be26b6&scoped=true&", function () {
      api.rerender('a5be26b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/empty-cartridge-production-orders/add.vue"
export default component.exports